import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import ZonasListItemComponent from './ZonasListItemComponent';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ZonasFormZonasComponent from './ZonasFormZonasComponent';
import stylee from './ZonasComponent.module.css'
import { useSelector, useDispatch } from 'react-redux'
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import MapaComponent from './MapaComponent';
import { getZonas } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import { obtenerMesZona } from '../../../redux/DucksUnidadInspeccion/MesZonaDuck';


function ZonasListComponent() {
    //const zonasbase = useSelector(store => store.MesZona.zonas);
    const [zonasbase, setzonasbase] = React.useState([]);
    const dispach = useDispatch();
    const [zonaModify, setZonaModify] = React.useState(null)

    const [zonas, setZonas] = React.useState([])

    const [openFormZonas, setOpenFormZonas] = React.useState(false);

    const [filtroOaxaca, setFiltroOaxaca] = React.useState(false)

    const handleOpenFormZonas = () => setOpenFormZonas(true);


    React.useEffect(() => {
        zonasbase
    }, [zonasbase])

    const handleCloseFormZonas = () => {
        setOpenFormZonas(false);
        setZonaModify(null);
        actualizarZonas()
    }

    const handleEditarZona = (zona) => {
        handleOpenFormZonas()
        setZonaModify(zona)
    }

    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    const isOaxaca = () => {
        setFiltroOaxaca(true)
        setZonas(zonasbase.filter((zona => zona.zona.tipozona == 0)).filter((value, index, self) => self.findIndex(v => v.zona.idzona === value.zona.idzona) === index));
    }

    const isExterior = () => {
        setFiltroOaxaca(false)
        setZonas(zonasbase.filter((zona => zona.zona.tipozona == 1)).filter((value, index, self) => self.findIndex(v => v.zona.idzona === value.zona.idzona) === index));
    }

    React.useEffect(() => {
        dispach(getZonas())
        dispach(obtenerMesZona()).then((res) => {
            setzonasbase(res.payload.data.data)
            console.log("actualizado zonas")
        })
    }, []);

    React.useEffect(() => {
        console.log("actualizado zonas")
        if (filtroOaxaca === true) {
            console.log("actualizado zonas 1")
            setZonas(zonasbase.filter((zona => zona.zona.tipozona == 0)).filter((value, index, self) => self.findIndex(v => v.zona.idzona === value.zona.idzona) === index));
        } else {
            console.log("actualizado zonas 2")
            setZonas(zonasbase.filter((zona => zona.zona.tipozona == 1)).filter((value, index, self) => self.findIndex(v => v.zona.idzona === value.zona.idzona) === index));
        }
    }, [filtroOaxaca, zonasbase]);

    const actualizarZonas = () => {
        dispach(getZonas())
        dispach(obtenerMesZona()).then((res) => {
            setzonasbase(res.payload.data.data)
            console.log("aqui")
        })
    }

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1000,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };

    const modalFormZonas = () => {
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openFormZonas}
                onClose={handleCloseFormZonas}
            >
                <Fade in={openFormZonas}>
                    <Box sx={style}>
                        <ZonasFormZonasComponent zonaModify={zonaModify} actualizarZonas={actualizarZonas} onClose={handleCloseFormZonas} />
                    </Box>
                </Fade>
            </Modal>
        )
    }

    return (
        <Fragment><br />
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 center`}>
                <br />
                <div className='row'>
                    <div className='col-4'>
                        <h1 className={`${stylee.tituloForm}`}>Lista de Zonas</h1>
                    </div>
                    <div className='col-8' style={{ textAlign: 'right' }}>
                        <label className='me-5'>Nomenclatura: <button className='badge bg-success text-light' onClick={isOaxaca}>OAXACA</button>
                            <button className='badge bg-primary text-light' onClick={isExterior}>EXTERIOR</button> </label>
                        {/* <button onClick={handleOpenFormZonas} className='btn btn-success'>Añadir Zona</button> */}
                    </div>
                </div>
                {
                    zonas.map((zona, index) => {
                        if (zona.zona.isactivo) {
                            return (
                                <ZonasListItemComponent key={index} zona={zona} actualizarZonas={actualizarZonas} handleEditarZona={handleEditarZona} ></ZonasListItemComponent>
                            );
                        }
                    })
                }
                <hr />
                <div className='col-4'>
                    <h3 className={`${stylee.tituloForm}`}>Zonas Inactivas</h3>
                </div>
                {
                    zonas.map((zona, index) => {
                        if (!zona.zona.isactivo) {
                            return (
                                <ZonasListItemComponent key={index} zona={zona} actualizarZonas={actualizarZonas} handleEditarZona={handleEditarZona} ></ZonasListItemComponent>
                            );
                        }
                    })
                }
            </div>
            {modalFormZonas()}
        </Fragment>

    );
};


export default withRouter(ZonasListComponent)
